import { Grid, Select, MenuItem, InputLabel, Box, CircularProgress, Tooltip, SelectChangeEvent, FormControl } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { IFormController } from '../types';
import Theme from '../../../Themes/main.theme';
import { useState } from 'react';
import ConditionalWrapper from '../../ConditionalWrapper/ConditionalWrapper';

const SelectType = (props: IFormController) => {
  const {
    label, name, formik, options, required, info, selectedItem, filtersDesign, customLabel, ...rest 
  } = props;
  const LOADER_SIZE = 20;
  
  const [value, setValue] = useState('');
  const handleChange = (e: SelectChangeEvent) => {
    formik?.setFieldValue(name, e.target.value);
    setValue(e.target.value as string);
    selectedItem && selectedItem(e.target.value);
  };

  return (
    <Grid>
      <Box>
        <ConditionalWrapper condition={!!customLabel} 
          wrapper={(children) => <FormControl fullWidth>{children}</FormControl>}>
          <Box display='flex' alignItems='center'>
            <InputLabel
              id='demo-simple-select-helper-label'
              disabled={props.disabled}
              required={required}
              sx={{...(!customLabel && {my: 2 }),
                textAlign: 'left',
                textStyle: 'none',
              }}
            >
              {label}
            </InputLabel>
            {info ? 
              <Tooltip
                PopperProps={{
                  disablePortal: true
                }} title={props?.tooltip}
                placement='right-start'>
                <InfoIcon sx={{color: Theme?.iconColor?.main, ml: 1, fontSize: '17px'}}/>
              </Tooltip>
              : null
            }

          </Box>
          <Select
            name={name}
            value={value}
            labelId='demo-simple-select-helper-label'
            label={customLabel
              ? label
              : null}
            MenuProps={{ disablePortal: true }}
            fullWidth
            sx={{ textAlign: 'left', minWidth: 200, ...(filtersDesign && { borderRadius: '24px'}) }}
            id={String(label)}
            inputProps={{ 'aria-label': 'Without label' }}
            {...formik?.getFieldProps(`${name}`)}
            onChange={(e) => handleChange(e)} //must be below formik?.getFieldProps else it will be overwritten
            {...rest}
          >
            {options?.map((option) => {
              if (options.length < 1) {
                return (
                  <MenuItem key={option.key} value={option.value as any}>
                    {<Box sx={{ display: 'flex' }}>
                      <CircularProgress size={LOADER_SIZE} />
                    </Box>}
                  </MenuItem>
                );
              }
              return (
                <MenuItem key={option.key} value={option.value as any}>
                  {option.key}
                </MenuItem>
              );
            })
            }
          </Select>
        </ConditionalWrapper>
      </Box>
    </Grid>
  );
};

export default SelectType;
